<template>
  <div class="aichat-container">
    <!-- 100자이상일 경우 팝업 -->
    <AlertModalV2 v-if="isTextCountWarningModal" @confirm-btn="isTextCountWarningModal = false">
      <template #alertmodal-nontitle>
        메세지는 최대 100자까지 입력 가능합니다.
      </template>
    </AlertModalV2>
    <!-- 이용 제한  -->
    <AlertModalV2 v-if="isLimitedChat" @confirm-btn="isLimitedChat = false">
      <template #alertmodal-nontitle>
        {{ errorText }}
      </template>
    </AlertModalV2>
    <!-- 음악 분위기 300자 제한 팝업 -->
    <AlertModalV2 v-if="isLimitedMusicMood" @confirm-btn="isLimitedMusicMood = false">
      <template #alertmodal-nontitle>
        음악 분위기는 300자까지만 입력 가능합니다.
      </template>
    </AlertModalV2>
    <!-- 가사 3000자 제한 팝업-->
    <AlertModalV2 v-if="isLimitedLyrics" @confirm-btn="isLimitedLyrics = false">
      <template #alertmodal-nontitle>
        가사는 3000자까지만 입력 가능합니다.
      </template>
    </AlertModalV2>
    <!-- 제목 80지 제한 팝업-->
    <AlertModalV2 v-if="isLimitedTitle" @confirm-btn="isLimitedTitle = false">
      <template #alertmodal-nontitle>
        제목은 80자까지만 입력 가능합니다.
      </template>
    </AlertModalV2>
    <!-- 제목 중복 여부 -->
    <AlertModalV2 v-if="isDuplicateTitle" @confirm-btn="isDuplicateTitle = false">
      <template #alertmodal-nontitle>
        이미 등록된 곡 제목입니다.
      </template>
    </AlertModalV2>
    <!-- 제목 중복 여부 -->
    <AlertModalV2 v-if="isLimitedInfo" @confirm-btn="isLimitedInfo = false">
      <template #alertmodal-nontitle>
        메뉴/내용은 80자까지만 입력가능합니다
      </template>
    </AlertModalV2>

    <!-- 이번달 이용 횟수를 모두 사용하셨어요. -->
    <AlertModalV2 v-if="isOverUser" @confirm-btn="isOverUser = false">
      <template #alertmodal-nontitle>
        이번달 이용 횟수를 모두 사용하셨어요.
      </template>
    </AlertModalV2>
    <!-- 채널 완료 로딩 -->
    <CommonSpainnerLoading v-if="isSpinnerLoading">
      <template #loadingtext>
        {{ channelName }}에 어울리는 <br />
        채널을 만드는 중이에요.
      </template>
    </CommonSpainnerLoading>

    <!-- 채팅 리스트 -->
    <ul class="flex_column aichat" ref="aichatlist">
      <li class="you">
        <p class="welcome-message" ref="welcome"></p>
      </li>
      <!-- 채팅 리스트 -->
      <template v-for="(item, index) in chatList">
        <!-- 예시 문장 example-->
        <li :key="'chat' + index" v-if="item.contentstype === 'example'" class="you fade-in example">
          <p class="recommend-ai cursor" @click="onClickExampleText(item.contents)">{{ item.contents }}</p>
        </li>
        <!-- 스페이스 등록 선택 문장  recommend-emotion -->
        <li
          class="you selectcuration"
          :key="'chatelseif' + index"
          v-else-if="item.contentstype === 'recommend-emotion'"
        >
          <p class="welcome-message" :ref="item.reftype"></p>

          <!-- 색상 -->
          <div v-if="item.reftype === 'colorref'" class="colorlist">
            <ChipComponent
              v-for="colorItem in colorList"
              :key="colorItem.id"
              v-bind="colorItem.props"
              @click-chip="onClickSelectColor(colorItem)"
            >
              <template #chipname>
                <img class="colorimg" :src="colorItem.url" alt="화이트" />
                {{ colorItem.name }}</template
              >
            </ChipComponent>
          </div>

          <!-- 소재 -->
          <div v-if="item.reftype === 'materialref'" class="materiallist">
            <ChipComponent
              v-for="materialItem in materialList"
              :key="materialItem.id"
              v-bind="materialItem.props"
              @click-chip="onClickSelectMaterial(materialItem)"
            >
              <template #chipname> {{ materialItem.koText }}</template>
            </ChipComponent>
          </div>
          <!-- 고객층 -->
          <div v-if="item.reftype === 'targetref'" class="targetlist">
            <ChipComponent
              v-for="targetItem in targetList"
              :key="targetItem.id"
              v-bind="targetItem.props"
              @click-chip="onClickTarget(targetItem)"
            >
              <template #chipname> {{ targetItem.koText }}</template>
            </ChipComponent>
          </div>

          <!-- 안내 문구 -->
          <div v-if="item.reftype === 'preferinforef'" class="preferinfo-list fade-in">
            <p class="preferinfo-item">“신나고 경쾌한 음악을 추천해줘”</p>
            <p class="preferinfo-item">“조용하고 집중이 잘되는 음악을 추천해줘”</p>
          </div>
        </li>

        <!-- AI 추천 문장 recommend-ai-->
        <li :key="'chataichat' + index" v-else-if="item.contentstype === 'recommend-ai'" class="you fade-in">
          <div class="flex_column">
            <p class="welcome-message" :ref="item.reftype"></p>
            <ul class="recommend" v-if="item.isShowImage">
              <li
                class="recommend-channel-wrap"
                v-for="(recommItem, recommIndex) in item['recommendList']"
                :class="recommItem.isDisable ? 'disable' : ''"
                :key="'recommIndex' + recommIndex"
              >
                <div>
                  <div class="recommend-channelimg-container">
                    <!-- 이미지 리스트 -->
                    <img
                      class="recommend-channelimg"
                      v-for="imgItem in recommItem['imageList']"
                      :key="imgItem"
                      :src="imgItem"
                    />
                  </div>
                  <p class="artist-list">{{ recommItem['artist'] }}</p>
                  <!-- AI 채널 텍스트 -->
                  <div
                    class="channel-recommendcard"
                    :class="recommItem.isSelected ? 'noselect' : 'cursor'"
                    @click="
                      recommItem.isDisable || recommItem.isSelected
                        ? () => {}
                        : finishChat(
                            item['convoNo'],
                            recommItem['recomItemNo'],
                            recommItem['recomReason'],
                            index,
                            recommIndex
                          )
                    "
                  >
                    <p class="channel-mood-description">
                      {{ recommItem['recomReason'] }}
                    </p>
                    <div class="channel-recommendcard-gowrap">
                      <img
                        class="channel-recommendcard-go"
                        src="/media/images/icon/arrow-go-icon.png"
                        alt="arrow-go-icon.png"
                      />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>

        <!-- 내 메세지 문장 me-->
        <li :key="'chatmessage' + index" v-else-if="item.type === 'me'" class="me fade-in">
          <div class="input-me" v-if="!item.isChange">
            <p class="input-me-text" v-html="item.contents"></p>
            <div v-if="item.isModify" class="modifiy-icon-wrap">
              <img
                class="modifiy-icon cursor"
                src="/media/images/icon/modifiy-icon.png"
                @click="item.isChange = true"
                alt="수정"
              />
            </div>
          </div>
          <ModifyTextArea
            v-if="item.isChange"
            :contents="item.contents"
            :placeholder="'수정할 내용을 입력해주세요'"
            @change-textarea="(val, self) => onChangeModifyTextArea(val, item, index, self)"
            @cancelbtn-event="item.isChange = false"
            @savebtn-event="val => onSaveBtn(val, item, index)"
          />
        </li>

        <!-- AI 채널 로딩 loading-aichannel -->
        <li
          :key="'chataichat-loading' + index"
          v-else-if="item.contentstype === 'loading-aichannel'"
          class="you fade-in"
        >
          <div class="flex_column">
            <p class="welcome-message" :ref="item.reftype"></p>
          </div>
        </li>

        <!-- AI 안내문장 aimusic-info -->
        <li :key="'chatmessage' + index" class="aimusic-infochat" v-else-if="item.type === 'aimusic-info'">
          <div class="flex_column">
            <p class="welcome-message" ref="aimusicInfoChat"></p>
            <template v-if="item.textlist">
              <ul class="aimusic-infochatlist" v-for="(textItem, textIdx) in item.textlist" :key="'infochat' + textIdx">
                <li class="aimusic-infochat-item fade-in" v-html="textItem"></li>
              </ul>
            </template>
          </div>
        </li>

        <!-- AI 뮤직 aimusic-->
        <li :key="'chatmessage' + index" v-else-if="item.type === 'aimusic'" class="me fade-in">
          <p class="input-me">
            {{ item.contents }}
          </p>
        </li>

        <!-- AI 뮤직 가사선택 aimusic-lyrics -->
        <li :key="'chatmessage' + index" class="aimusic-infochat" v-else-if="item.type === 'aimusic-lyrics'">
          <div class="flex_column">
            <p class="welcome-message" ref="aimusicLyrics"></p>
            <!-- AI 뮤직 가사선택 리스트 -->
            <div class="lyrics-select-list fade-in" v-if="item.selectList.length > 0">
              <a
                v-for="(selectItem, selectIdx) in item.selectList"
                :key="'selectItem' + selectIdx"
                tabindex="0"
                :data-selectidx="selectIdx"
                class="lyrics-select-item cursor"
                @click="onClickLyrics(selectItem.lyricsType, selectItem.text, $event, index)"
                >{{ selectItem.text }}</a
              >
            </div>
          </div>
        </li>

        <!-- AI 뮤직 곡-제목 입력 aimusic-title -->
        <li :key="'chatmessage' + index" class="aimusic-infochat" v-else-if="item.type === 'aimusic-title'">
          <p class="welcome-message" ref="aiMusicTitle"></p>
        </li>

        <!-- AI 뮤직 직접입력 aimusic-manual -->
        <li :key="'chatmessage' + index" class="aimusic-infochat" v-else-if="item.type === 'aimusic-manual'">
          <p class="welcome-message" ref="aiMusicManual"></p>
        </li>

        <!-- AI 뮤직 AI 추천 aimusic-generated -->
        <li :key="'chatmessage' + index" class="aimusic-infochat" v-else-if="item.type === 'aimusic-generated'">
          <div class="flex_column">
            <p class="welcome-message" ref="aiMusicGenerated"></p>
            <ul class="aimusic-infochatlist">
              <li class="aimusic-infochat-item fade-in">EX. {{ aiMusicExampleText }}</li>
            </ul>
          </div>
        </li>

        <!-- AI 뮤직 곡-제목 입력 aimusic-mood -->
        <li :key="'chatmessage' + index" class="aimusic-infochat" v-else-if="item.type === 'aimusic-mood'">
          <div class="flex_column">
            <p class="welcome-message" ref="aiMusicMood"></p>
            <ul class="aimusic-infochatlist">
              <li class="aimusic-infochat-item fade-in">EX. {{ aiMusicExampleText }}</li>
            </ul>
          </div>
        </li>
      </template>
      <!-- 로딩바  -->
      <li class="you" v-if="isLoading">
        <ThreeBounce />
      </li>
    </ul>
    <!-- Input Box -->
    <div class="w_100per chatbox">
      <ChatTextAreaBox
        ref="chatTextAreaBox"
        :placeholder="'메세지를 입력해보세요.'"
        :disabled="isInputDisabled"
        :maxlength="textAreaMaxLength"
        @enter-event="onEnterEventTextArea"
        @change-textarea="onChangeTextArea"
        @click-sendicon="onClickSendIcon"
        @change-height="onChangeHeight"
      />
    </div>
  </div>
</template>
<script>
import Typed from 'typed.js';
import ThreeBounce from '../ThreeBounce/ThreeBounce.vue';
import ChipComponent from '../Chip/ChipComponent.vue';
import CommonSpainnerLoading from '../common/CommonSpainnerLoading.vue';
import ModifyTextArea from '../AiMusic/ModifyTextArea.vue';
import ChatTextAreaBox from './ChatTextAreaBox.vue';
import AlertModalV2 from '../modal/AlertModalV2.vue';
import {
  conversationApi,
  conversationForCurationApi,
  conversationForSpaceApi,
  finishChatApi,
  finishChatForCurationApi,
  finishChatForSpaceApi,
  selectExampleQuestionListApi,
  startChatApi,
  startChatForCurationApi,
  startChatForSpaceApi
} from '@/service/api/aichatApi';
import { generateMusicApi, getWelcomeMsgApi, selectExampleQuestionListAiMusicApi } from '@/service/api/mySoundApi';
import { decodeHtmlEntities } from '@/utils/Utils';
export default {
  props: {
    aichanneltype: {
      type: String,
      default: '', // addspace(신규 스페이스 등록) , timecuration(시간별 큐레이션) , aichannel(AI 채널), aimusic(AI음악 생성)
      required: false
    },
    spaceid: {
      type: String,
      default: null,
      required: false
    },
    spacename: {
      type: String,
      default: '',
      required: false
    }
  },
  emits: ['send-curationinfo', 'space-complete'],
  components: {
    ThreeBounce,
    ChipComponent,
    CommonSpainnerLoading,
    AlertModalV2,
    ModifyTextArea,
    ChatTextAreaBox
  },
  created() {
    if (this.aichanneltype === 'aimusic') {
      this.textAreaMaxLength = 80;
    }

    this.colorList = this.$store.getters['curation/getColorsV2'].map(item => {
      return {
        ...item,
        props: this.chipProps
      };
    });

    this.materialList = this.$store.getters['curation/getMaterialV2'].map(item => {
      return {
        ...item,
        props: this.chipProps
      };
    });

    this.targetList = this.$store.getters['curation/getTarget'].map(item => {
      return {
        ...item,
        props: this.chipProps
      };
    });
  },
  data() {
    return {
      isTextCountWarningModal: false,
      isLoading: false,
      isLimitedChat: false,
      isLimitedInfo: false, // 홍보 텍스트
      isLimitedMusicMood: false, // 음악 분위기 300자 제한
      isLimitedLyrics: false, // 가사 3000자 제한
      isLimitedTitle: false, // 제목 80자 제한
      isNotInsertAiMusicInput: false, // AI 음악 입력 여부(한번만 입력 가능하고, 수정 가능)
      isSelectedLyrics: false, // 가사 선택 여부
      isDuplicateTitle: false, // 노래 제목 중복 여부
      isOverUser: false, // 사용 횟수 초과
      isSpinnerLoading: false,
      mood: null, // 분위기 텍스트
      mode: null, // 가사 선택 방시
      title: null, // 곡 제목
      lyrics: null, // 가사
      btnDisabled: false,
      textAreaMaxLength: 100, // 채팅 InputBox 최대길이
      aimusiceExampleList: [],
      colorList: [],
      materialList: [],
      targetList: [],
      isSelectedColor: null,
      isSelectMaterial: null,
      isSelectTarget: null,
      chipProps: {
        bg: 'white',
        size: 'lg',
        border: 'br-black300',
        ftcolor: 'font-black500'
      },
      activeProps: {
        bg: 'white',
        size: 'lg',
        border: 'br-black800'
      },

      chatText: '',
      status: '',
      userId: this.$cookies.get('userId'),
      chatList: [],
      exampleList: [],
      content: `안녕하세요, 어플레이즈 AI 입니다. 간단한 채팅을 통해, 고객님의 매장에 어울리는 &lt;br&gt;음악을 만나보세요!`,
      chatId: null,
      convoNo: -1,
      errorText: '',
      aiMusicChatStep: 0 //
    };
  },
  async mounted() {
    /* 예시문장 GET */
    await this.commonExampleQuestionList();
    await this.$nextTick();
    /* Welcome문장 세팅 */
    this.startChat();
  },
  methods: {
    onChangeHeight(val) {
      if (val > 80) {
        this.$refs.aichatlist.style.height = `calc(100% - ${val}px)`;
      } else {
        this.$refs.aichatlist.style.height = `calc(100% - 80px)`;
      }
    },
    /**
     * @description Artist 높이 맞추기
     */
    setMaxHeightForArtistList() {
      const recommendLists = document.querySelectorAll('ul.recommend');

      recommendLists.forEach(list => {
        const artistItems = list.querySelectorAll('.artist-list');
        let maxHeight = 0;

        // 1. 높이 초기화 후 최대 높이 계산
        artistItems.forEach(el => {
          el.style.height = 'auto'; // 재계산 위해 초기화
          const height = el.offsetHeight;

          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        // 2. 최대 높이로 모든 요소 설정
        artistItems.forEach(el => {
          el.style.height = `${maxHeight}px`;
        });
      });
    },
    /**
     * @description : Index까지 선택됨 처리
     * @param index
     */
    setSelected(index) {
      for (let i = 0; i <= index; i++) {
        if (this.chatList[i].recommendList) {
          this.chatList[i].recommendList.forEach(item => {
            item.isSelected = true;
          });
        }
      }
    },
    /**
     * @description input 입력 후 채널 호출
     * @param convoNo
     * @param recomItemNo
     * @param recomReason
     * @param index
     * @param recommIndex
     */
    async finishChat(convoNo, recomItemNo, recomReason, index, recommIndex) {
      if (this.isLoading) return;
      if (this.aichanneltype === 'aichannel') {
        this.isLoading = true;
        this.chatList.push({
          type: 'you',
          contentstype: 'loading-aichannel',
          reftype: 'recommendchatref'
        });
        await this.$nextTick();

        const recoIdx = recommIndex === 0 ? 1 : 0;
        if (this.chatList[index].recommendList[recoIdx]) {
          this.chatList[index].recommendList[recoIdx].isDisable = true;
          this.chatList[index].recommendList[recoIdx].isSelected = true;
        }
        this.setSelected(index);

        setTimeout(() => {
          this.scrollBottom();
        }, 500);
        this.typed(
          this.$refs.recommendchatref[this.$refs.recommendchatref.length - 1],
          `${recomReason}을 재생해드릴게요`,
          async () => {
            try {
              const { data } = await finishChatApi({
                userId: this.userId,
                spaceId: this.spaceid,
                chatId: this.chatId,
                convoNo,
                recomItemNo
              });
              const { resultCd, result: curationId } = data;
              if (resultCd === '0000') {
                await this.$store.dispatch('player/createNewChannel', {
                  curationId
                });
              } else {
                throw Error(resultCd);
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.isLoading = false;
            }
          }
        );
      } else if (this.aichanneltype === 'addspace') {
        this.isSpinnerLoading = true;
        try {
          const { data } = await finishChatForSpaceApi({
            userId: this.userId,
            spaceId: this.spaceid,
            chatId: this.chatId,
            convoNo,
            recomItemNo
          });
          const { resultCd, result: curationId } = data;
          if (resultCd === '0000') {
            this.$emit('space-complete', {
              spaceId: this.spaceid,
              curationId,
              endFn: () => {
                this.isSpinnerLoading = false;
              }
            });
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          console.log(error);
        }
      } else if (this.aichanneltype === 'timecuration') {
        this.isSpinnerLoading = true;
        try {
          const { data } = await finishChatForCurationApi({
            userId: this.userId,
            spaceId: this.spaceid,
            chatId: this.chatId,
            convoNo,
            recomItemNo
          });
          const { resultCd, result: curationInfo } = data;
          if (resultCd === '0000') {
            this.$emit('send-curationinfo', curationInfo);
            this.isSpinnerLoading = false;
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.isSpinnerLoading = false;
        }
      }
    },
    /**
     * @description 스크롤 하단 이동
     */
    scrollBottom() {
      this.$refs.aichatlist.scrollTo({
        top: this.$refs.aichatlist.scrollHeight,
        behavior: 'smooth'
      });
    },
    /**
     * @description 스페이스 생성시 색상 선택
     * @param item
     */
    async onClickSelectColor(item) {
      if (this.isSelectedColor) return;
      this.$gatag.event('web_add_space_chat_page_color_chip'); // 스페이스 추가 색상 선택
      item.props = this.activeProps;

      await this.$nextTick();
      this.isSelectedColor = item.value;
      this.chatList.push({
        type: 'me',
        contents: item.name
      });
      setTimeout(() => {
        this.chatSelectMaterial();
        this.scrollBottom();
      }, 500);
    },
    /**
     * @description 스페이스 생성시 소재 선택
     * @param item
     */
    async onClickSelectMaterial(item) {
      if (this.isSelectMaterial) return;
      this.$gatag.event('web_add_space_chat_page_material_chip'); // 스페이스 추가 재질 선택
      item.props = this.activeProps;
      await this.$nextTick();
      this.isSelectMaterial = item.value;
      this.chatList.push({
        type: 'me',
        contents: item.koText
      });
      setTimeout(() => {
        this.chatSelectTarget();
        this.scrollBottom();
      }, 500);
    },
    /**
     * @description 스페이스 생성시 고객층 선택
     * @param item
     */
    async onClickTarget(item) {
      if (this.isSelectTarget) return;
      item.props = this.activeProps;
      this.$gatag.event('web_add_space_chat_page_target_chip'); // 스페이스 추가 고객층 선택
      await this.$nextTick();
      this.isSelectTarget = item.value;
      this.chatList.push({
        type: 'me',
        contents: item.koText
      });
      setTimeout(() => {
        this.chatInfoPreferMusic();
      }, 500);
    },
    onChangeTextArea(val) {
      if (val.length >= this.textAreaMaxLength) {
        if (this.aichanneltype === 'aimusic' && this.aiMusicChatStep === 0) {
          // 홍보 안내의 경우
          this.isLimitedInfo = true;
        } else if (this.aichanneltype === 'aimusic' && this.aiMusicChatStep === 1) {
          // 분위기의 경우
          this.isLimitedMusicMood = true;
        } else if (
          // 가사의 경우
          this.aichanneltype === 'aimusic' &&
          this.aiMusicChatStep === 2
        ) {
          this.isLimitedLyrics = true;
        } else if (this.aichanneltype === 'aimusic' && this.aiMusicChatStep === 3) {
          // 제목의 경우
          this.isLimitedTitle = true;
        } else {
          this.isTextCountWarningModal = true;
        }

        this.chatText = val.slice(0, this.textAreaMaxLength);
        return;
      }

      this.chatText = val.slice(0, this.textAreaMaxLength);
    },
    /**
     * @description 추천 채널
     * @param param
     */
    async recommendTxt(param = { list: [], recomYn: 'N', recomMessage: '', content: '', convoNo: -1 }) {
      // eslint-disable-next-line no-unused-vars
      const { list, recomYn, recomMessage, content, convoNo } = param;
      if (recomYn === 'Y' && Array.isArray(list)) {
        const recommendList = [];
        list.forEach(item => {
          const imageList = item.artistList.map(item => item.imgUrl);
          const artistStr = item.artistList.map(item => item.artistNm).join(',');

          recommendList.push({
            recomItemNo: item.recomItemNo,
            imageList,
            artist: decodeHtmlEntities(artistStr),
            recomReason: item.recomReason,
            isDisable: false,
            isSelected: false
          });
        });

        this.chatList.push({
          type: 'you',
          contentstype: 'recommend-ai',
          reftype: 'aichatref',
          isShowImage: false,
          convoNo,
          recommendList
        });
        await this.$nextTick();
        setTimeout(() => {
          this.scrollBottom();
        }, 500);
        this.typed(
          this.$refs.aichatref[this.$refs.aichatref.length - 1],
          `${content} <br/> ${recomMessage}`,
          async () => {
            if (recomYn === 'Y') {
              this.chatList[this.chatList.length - 1].isShowImage = true;

              setTimeout(() => {
                this.scrollBottom();
              }, 500);
              await this.$nextTick();
              this.setMaxHeightForArtistList();
            }
          }
        );
      } else if (recomYn === 'N') {
        this.chatList.push({
          type: 'you',
          contentstype: 'recommend-ai',
          reftype: 'aichatref',
          isShowImage: false,
          convoNo,
          recommendList: []
        });
        await this.$nextTick();
        setTimeout(() => {
          this.scrollBottom();
        }, 500);
        this.typed(this.$refs.aichatref[this.$refs.aichatref.length - 1], `${content}`, async () => {
          setTimeout(() => {
            this.scrollBottom();
          }, 500);
        });
      }
    },
    /**
     * @description 예시문구 선택
     * @param txt
     */
    onClickExampleText(txt) {
      this.$gatag.event('web_ai_chat_page_sample_text'); // ai 채팅 페이지 샘플 텍스트 선택
      if (this.isLoading || this.btnDisabled) return;
      this.isLoading = true;
      this.chatList.push({
        type: 'me',
        contents: txt
      });
      this.sendChat(txt);
      setTimeout(() => {
        this.scrollBottom();
      }, 500);
    },
    onClickSendIcon() {
      this.onAddChat();
    },
    /**
     * @description input입력 후 채팅창 추가
     */
    async onAddChat() {
      if (!this.chatText.trim()) return;

      // 직전의 chatlist item이 manual / ai-generated 인 경우
      const lastChatItem = this.chatList[this.chatList.length - 1];

      // 마지막이 aimusic-generated(AI가 직접 만드는 방식) aimusic-manual(직접 가사 입력)
      if (lastChatItem.type) {
        const { type } = lastChatItem;

        if (type === 'aimusic-generated' || type === 'aimusic-manual' || type === 'aimusic-mood') {
          this.btnDisabled = true;
          this.onSendLyrics(type);

          return;
        } else if (type === 'aimusic-title') {
          // 최종 처리 필요
          try {
            setTimeout(() => {
              this.scrollBottom();
            }, 500);
            const { data } = await generateMusicApi(
              this.userId,
              this.spaceid,
              this.mood,
              this.mode,
              this.chatText.trim(),
              this.lyrics
            );

            const { resultCd, result: genMusicId } = data;
            if (resultCd === '0000') {
              this.$router.push({ path: `/complete/aimusic/${genMusicId}` });
            }
          } catch (error) {
            if (error.response) {
              const { data } = error.response;
              const { resultCd } = data;
              if (resultCd === '4003') {
                this.$gatag.event('web_ai_music_generate_page_duplicate_error'); // 로고송 제목 중복 팝업
                this.isDuplicateTitle = true;
              } else if (resultCd === '24003') {
                this.isOverUser = true;
              }
            }
            console.log('error : ', error);
          }
          return;
        }
      }

      // 마지막에 채팅 리스트 추가
      this.chatList.push({
        type: 'me',
        contents: this.chatText,
        isModify: this.aichanneltype === 'aimusic' && !this.isNotInsertAiMusicInput, // 변경 가능 여부
        modifyDetailType: this.aichanneltype === 'aimusic' && !this.isNotInsertAiMusicInput ? 'aimusic' : '',
        isChange: false // 변경 여부
      });

      if (this.aichanneltype === 'aimusic') this.isNotInsertAiMusicInput = true;
      this.sendChat(this.chatText);
      this.chatText = '';

      setTimeout(() => {
        this.scrollBottom();
      }, 500);

      this.$refs.aichatlist.style.height = `calc(100% - 80px)`;
    },
    /**
     * @description 가사 및 분위기 입력
     */
    async onSendLyrics(modifyDetailType) {
      this.chatList.push({
        type: 'me',
        contents: this.chatText,
        isModify: true, // 변경 가능 여부
        modifyDetailType: modifyDetailType,
        isChange: false // 변경 여부
      });
      if (modifyDetailType === 'aimusic-generated' || modifyDetailType === 'aimusic-mood') {
        this.mood = this.chatText;
      } else {
        this.lyrics = this.chatText;
      }

      this.chatText = '';

      setTimeout(() => {
        this.scrollBottom();
      }, 500);

      this.$refs.aichatlist.style.height = `calc(100% - 80px)`;

      // AI입력인 경우 노래제목 입력

      if (modifyDetailType === 'aimusic-generated' || modifyDetailType === 'aimusic-mood') {
        this.chatList.push({
          type: 'aimusic-title'
        });
        await this.$nextTick();
        this.setAiMusicTitle(modifyDetailType);
        this.btnDisabled = false;
      } else {
        // 직접입력인 경우 분위기 입력 => 노래제목 입력
        this.aiMusicChatStep = 1;
        this.setAiMusicMood();
      }
    },
    /**
     * @description AI뮤직 분위기 입력
     */
    async setAiMusicMood() {
      this.chatList.push({
        type: 'aimusic-mood'
      });
      await this.$nextTick();
      const parser = new DOMParser();
      this.textAreaMaxLength = 300;
      this.typed(
        this.$refs.aiMusicMood[0],
        parser.parseFromString(`아주 매력적인 내용이에요!&lt;br&gt;음악은 어떤 분위기로 만들어 볼까요?`, 'text/html')
          .body.textContent,
        async () => {
          this.btnDisabled = false;
          this.scrollBottom();
        }
      );
    },
    /**
     * @description AI뮤직 제목 안내 문구
     * @param modifyDetailType
     */
    setAiMusicTitle(modifyDetailType) {
      const parser = new DOMParser();
      let text = '';
      if (modifyDetailType === 'aimusic-manual') {
        text = `아주 매력적인 가사네요!마지막으로, 곡 제목을 입력해 주세요.`;
      } else if (modifyDetailType === 'aimusic-generated' || modifyDetailType === 'aimusic-mood') {
        text = `마지막으로 곡 제목을 알려주시면 &lt;br&gt; ${this.spacename} 만을 위한 특별한 음악을 만들어 드릴게요!`;
      }
      this.aiMusicChatStep = 3;
      this.textAreaMaxLength = 80;
      this.typed(this.$refs.aiMusicTitle[0], parser.parseFromString(text, 'text/html').body.textContent, async () => {
        await this.$nextTick();
        this.scrollBottom();

        this.$refs.chatTextAreaBox.onClickBox();
      });
    },
    /**
     * @description TextArea
     */
    onEnterEventTextArea() {
      this.onAddChat();
    },
    /**
     * @description input 텍스트 추가
     * @param text
     */
    async sendChat(text) {
      if (this.aichanneltype === 'aichannel') {
        try {
          this.isLoading = true;
          const { data } = await conversationApi(this.userId, this.spaceid, this.chatId, text);
          const { resultCd, result } = data;
          if (resultCd === '0000') {
            const { recomList: list, recomYn, recomMessage, content, convoNo } = result;
            await this.recommendTxt({
              list,
              recomYn,
              recomMessage,
              content,
              convoNo
            });
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          this.startChatErrorHandling(error);
        } finally {
          this.isLoading = false;
        }
      } else if (this.aichanneltype === 'addspace') {
        this.isLoading = true;
        const param = {
          userId: this.userId,
          spaceId: this.spaceid,
          chatId: this.chatId,
          content: text,
          color: this.isSelectedColor,
          material: this.isSelectMaterial,
          target: this.isSelectTarget
        };
        try {
          const { data } = await conversationForSpaceApi(param);
          const { resultCd, result } = data;
          if (resultCd === '0000') {
            const { recomList: list, recomYn, recomMessage, content, convoNo } = result;
            await this.recommendTxt({
              list,
              recomYn,
              recomMessage,
              content,
              convoNo
            });
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          this.startChatErrorHandling(error);
        } finally {
          this.isLoading = false;
        }
      } else if (this.aichanneltype === 'timecuration') {
        this.isLoading = true;
        try {
          const { data } = await conversationForCurationApi(this.userId, this.spaceid, this.chatId, text);
          const { resultCd, result } = data;
          if (resultCd === '0000') {
            const { recomList: list, recomYn, recomMessage, content, convoNo } = result;
            await this.recommendTxt({
              list,
              recomYn,
              recomMessage,
              content,
              convoNo
            });
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          this.startChatErrorHandling(error);
        } finally {
          this.isLoading = false;
        }
      } else if (this.aichanneltype === 'aimusic') {
        // 가사 선택 - AI 분위기의 음악입력 한 경우
        if (this.isNotInsertAiMusicInput) {
          this.lyrics = text;
          const idx = this.chatList.push({
            type: 'aimusic-lyrics',
            selectList: []
          });
          this.btnDisabled = true;
          await this.$nextTick();

          const parser = new DOMParser();
          this.typed(
            this.$refs.aimusicLyrics[0],
            parser.parseFromString(`가사는 어떤 방식으로 만들고 싶으신가요?`, 'text/html').body.textContent,
            async () => {
              await this.$nextTick();
              this.chatList[idx - 1].selectList = [
                { lyricsType: 'ai-generated', text: '자동으로 만들어주세요' },
                { lyricsType: 'manual', text: '제가 직접 입력할게요' }
              ];
              this.scrollBottom();
            }
          );
        }
      }
    },
    /**
     * @description focus event
     */
    onFocusEvent() {
      this.status = 'error';
    },
    /**
     * @description blur event
     */
    onBlurEvent() {
      this.status = '';
    },
    /**
     * @description 예시 문장
     */
    async commonExampleQuestionList() {
      try {
        const { data } = await selectExampleQuestionListApi(this.userId, this.spaceid);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          if (Array.isArray(result)) {
            result.forEach(item => {
              this.exampleList.push({
                type: 'you',
                contentstype: 'example',
                contents: item
              });
            });
          }
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description 웰컴 종료
     */
    welcomeComplete() {
      this.exampleList.forEach((item, index) => {
        setTimeout(() => {
          this.chatList.push(item);
          if (index === this.exampleList.length - 1) {
            this.btnDisabled = false;
          }
        }, index * 500);
      });
    },
    /**
     * @description AI뮤직 안내 문구 종료 함수
     */
    async welcomeCompleteAiMusic() {
      this.btnDisabled = false;
      const parser = new DOMParser();
      const idx = this.chatList.push({
        type: 'aimusic-info',
        textlist: []
      });
      await this.$nextTick();
      this.typed(
        this.$refs.aimusicInfoChat[0],
        parser.parseFromString(`매장에서 특별히 홍보하고 싶으신 메뉴/내용이 있으신가요?`, 'text/html').body.textContent,
        async () => {
          await this.$nextTick();
          this.chatList[idx - 1].textlist = [
            'EX. 우리 매장은 항상 고객님들께 밝고 친절하게 응대하고 있어요. <br/> 우리 매장은 항상 좋은 품질의 제품만을 엄선하고 있어요.'
          ];
          this.scrollBottom();
          this.$refs.chatTextAreaBox.focus();
          this.$refs.chatTextAreaBox.onClickBox();
        }
      );
    },
    /**
     * @description 선호음악 문구
     */
    async chatInfoPreferMusic() {
      const parser = new DOMParser();
      this.chatList.push({
        type: 'you',
        contentstype: 'recommend-emotion',
        reftype: 'preferinforef'
      });
      await this.$nextTick();
      this.scrollBottom();
      this.typed(
        this.$refs.preferinforef[0],
        parser.parseFromString(`마지막으로, 선호하는 음악의 분위기를 자유롭게 알려주세요.`, 'text/html').body
          .textContent,
        () => {
          this.scrollBottom();
        }
      );
    },
    /**
     * @description 고객층 선택
     */
    async chatSelectTarget() {
      const parser = new DOMParser();
      this.chatList.push({
        type: 'you',
        contentstype: 'recommend-emotion',
        reftype: 'targetref'
      });
      await this.$nextTick();
      this.typed(
        this.$refs.targetref[0],
        parser.parseFromString(`매장에 방문하는 주요 고객층은 누구인가요?`, 'text/html').body.textContent,
        () => {
          setTimeout(() => {
            this.scrollBottom();
          }, 500);
        }
      );
    },
    /**
     * @description 소재 선택
     */
    async chatSelectMaterial() {
      const parser = new DOMParser();
      this.chatList.push({
        type: 'you',
        contentstype: 'recommend-emotion',
        reftype: 'materialref'
      });
      await this.$nextTick();
      this.typed(
        this.$refs.materialref[0],
        parser.parseFromString(`매장 인테리어의 주요 소재를 선택해주세요.`, 'text/html').body.textContent,
        () => {
          setTimeout(() => {
            this.scrollBottom();
          }, 500);
        }
      );
    },
    /**
     * @description 색상 선택하기
     */
    async chatSelectColor() {
      const parser = new DOMParser();
      this.chatList.push({
        type: 'you',
        contentstype: 'recommend-emotion',
        reftype: 'colorref'
      });
      await this.$nextTick();
      this.typed(
        this.$refs.colorref[0],
        parser.parseFromString(`먼저, 매장 인테리어의 주요 색상을 선택해주세요.`, 'text/html').body.textContent,
        () => {
          setTimeout(() => {
            this.scrollBottom();
          }, 500);
        }
      );
    },
    /**
     * @description 채팅 시작 에러 핸들링ㄴ
     * @param error
     */
    startChatErrorHandling(error) {
      if (error.response) {
        if (error.response.status === 400) {
          const { resultCd, resultMsg } = error.response.data;
          if (resultCd === '12004') {
            /* UNSUBSCRIBED_WITH_SPACE 일 경우 모달 처리 */
            if (this.$store.getters['auth/getAuthName'] === 'UNSUBSCRIBED_WITH_SPACE') {
              this.$gatag.event('web_main_page_subscribe_popup'); // 구독 팝업
              this.$store.commit('player/setIsOpenUndescribeModal', true);
            } else {
              this.$gatag.event('web_make_space_popup'); // 스페이스 만들기 팝업
              this.$store.commit('player/setIsOpenNewSpaceModal', true);
            }
          } else if (resultCd === '400') {
            /* UNSUBSCRIBED_NO_SPACE 일 경우 모달 처리  */
            this.$gatag.event('web_make_space_popup'); // 스페이스 만들기 팝업
            this.$store.commit('player/setIsOpenNewSpaceModal', true);
          } else {
            this.errorText = resultMsg;
            this.isLimitedChat = true;
          }
        }
      }
    },
    limiteChat(chList = [[], []]) {
      if (Array.isArray(chList)) {
        const [me, ai] = chList;
        if (me) {
          this.chatList.push({
            type: 'me',
            contents: me.content
          });
        }
        const { recomList: list, recomYn, recomMessage, content, convoNo, chatId: cId } = ai;
        this.chatId = cId;
        setTimeout(async () => {
          await this.recommendTxt({
            list,
            recomYn,
            recomMessage,
            content,
            convoNo
          });
        }, 500);
      }
    },
    /**
     * @description 채팅 시작하기
     */
    async startChat() {
      const parser = new DOMParser();
      if (this.aichanneltype === 'aichannel') {
        try {
          this.btnDisabled = true;
          const { data } = await startChatApi(this.userId, this.spaceid);
          const { result, resultCd } = data;
          if (resultCd === '0000') {
            const { chatId, content, aichatUsageLimit, chatList: chList } = result;
            if (!aichatUsageLimit) {
              this.chatId = chatId;
              this.typed(
                this.$refs.welcome,
                parser.parseFromString(content, 'text/html').body.textContent,
                this.welcomeComplete
              );
            } else {
              this.limiteChat(chList);
            }
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          this.startChatErrorHandling(error);
        }
      } else if (this.aichanneltype === 'addspace') {
        try {
          const { data } = await startChatForSpaceApi(this.userId, this.spaceid);
          const { result, resultCd } = data;
          if (resultCd === '0000') {
            // eslint-disable-next-line no-unused-vars
            const { chatId, content, convoNo, aichatUsageLimit, chatList: chList } = result;
            if (!aichatUsageLimit) {
              this.chatId = chatId;
              await this.$nextTick();
              this.typed(
                this.$refs.welcome,
                parser.parseFromString(content, 'text/html').body.textContent,
                this.chatSelectColor
              );
            } else {
              this.limiteChat(chList);
            }
          } else {
            throw Error(resultCd);
          }
        } catch (error) {
          this.startChatErrorHandling(error);
        }
      } else if (this.aichanneltype === 'timecuration') {
        try {
          const { data } = await startChatForCurationApi(this.userId, this.spaceid);
          const { result, resultCd } = data;
          if (resultCd === '0000') {
            const { chatId, content, aichatUsageLimit, chatList: chList } = result;
            if (!aichatUsageLimit) {
              this.chatId = chatId;
              this.typed(
                this.$refs.welcome,
                parser.parseFromString(content, 'text/html').body.textContent,
                this.welcomeComplete
              );
            } else {
              this.limiteChat(chList);
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else if (this.aichanneltype === 'aimusic') {
        this.btnDisabled = true;
        const { data } = await getWelcomeMsgApi(this.userId, this.spaceid);
        this.setAiMusicExampleTxt();
        const { result, resultCd } = data;
        let txt = null;
        if (resultCd === '0000') {
          txt = result;
        }

        this.typed(
          this.$refs.welcome,
          parser.parseFromString(txt, 'text/html').body.textContent,
          this.welcomeCompleteAiMusic
        );
      }
    },
    /**
     * @description AIMusic 예시문 문구 리스트
     */
    async setAiMusicExampleTxt() {
      try {
        const { data } = await selectExampleQuestionListAiMusicApi(this.userId, this.spaceid);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.aimusiceExampleList = result;
        } else {
          throw Error('selectExampleQuestionListAiMusicApi error : ', resultCd);
        }
      } catch (error) {
        console.log('setAiMusicExampleTxt : ', error);
      }
    },
    /**
     * @description 타이핑 애니메이션
     */
    typed(ele, html, completeFn) {
      return new Typed(ele, {
        strings: [html],
        typeSpeed: 20,
        showCursor: false,
        contentType: 'html',
        onComplete: async () => {
          if (completeFn) {
            completeFn();
          }
        }
      });
    },
    /**
     * @description 수정 텍스트 변경
     * @param text
     * @param item
     * @param idx
     */
    onChangeModifyTextArea(text, item, idx, self) {
      const { modifyDetailType } = item;
      if (modifyDetailType === 'aimusic' && text.length > 80) {
        if (self.sliceTextArea) {
          this.isLimitedInfo = true;
          // 80자
          self.sliceTextArea(80);
        }
      } else if (
        (modifyDetailType === 'aimusic-generated' || modifyDetailType === 'aimusic-mood') &&
        text.length > 300
      ) {
        if (self.sliceTextArea) {
          this.isLimitedMusicMood = true;
          // 300자
          self.sliceTextArea(300);
        }
      } else if (modifyDetailType === 'aimusic-manual' && text.length > 3000) {
        if (self.sliceTextArea) {
          this.isLimitedLyrics = true;
          // 3000자
          self.sliceTextArea(3000);
        }
      }
    },
    /**
     * @description InputText
     * @param text
     */
    async onSaveBtn(text, item, idx) {
      item.contents = text;
      item.isChange = false;

      const { modifyDetailType } = item;

      if (modifyDetailType === 'aimusic') {
        /* 분위기 변경했을때 */
        this.chatList.splice(idx + 1);
        await this.$nextTick();

        // 가사 다시 띄우기
        this.isSelectedLyrics = false;
        this.aiMusicChatStep = 2;
        setTimeout(() => {
          this.sendChat(text);
        }, 500);
      } else if (modifyDetailType === 'aimusic-generated' || modifyDetailType === 'aimusic-manual') {
        this.lyrics = text;

        // 가사 변경 하였을때
        this.chatList.splice(idx + 1);
        // 직접입력 && 가사 변경하는 경우 분위기 입력
        if (modifyDetailType === 'aimusic-manual') {
          this.aiMusicChatStep = 1;
          setTimeout(async () => {
            this.setAiMusicMood();
          }, 500);
        } else {
          setTimeout(async () => {
            this.chatList.push({
              type: 'aimusic-title'
            });
            await this.$nextTick();

            this.setAiMusicTitle(modifyDetailType);
          }, 500);
        }
      } else if (modifyDetailType === 'aimusic-mood') {
        this.mood = text;
        this.chatList.splice(idx + 1);
        setTimeout(async () => {
          this.chatList.push({
            type: 'aimusic-title'
          });
          await this.$nextTick();

          this.setAiMusicTitle(modifyDetailType);
        }, 500);
      }
    },
    /**
     * @description AIMusic 가사 클락
     */
    async onClickLyrics(type, text, event, idx) {
      if (this.isSelectedLyrics) return;
      this.btnDisabled = false;
      // 글자수 제한
      if (event) {
        if (event.target.classList.contains('active')) {
          return;
        }
        document.querySelectorAll('.lyrics-select-item ').forEach(item => {
          item.classList.remove('active');
        });
        event.target.classList.add('active');
      }

      // 다음 채팅 리스트가 있을 경우 split
      if (this.chatList[idx + 1]) {
        this.chatList.splice(idx + 1);
      }

      const parser = new DOMParser();
      this.isSelectedLyrics = true;
      if (type === 'manual') {
        this.$gatag.event('web_ai_music_generate_page_chat_lyrics_by_my_self'); // 로고송 가사 직접 입력
        this.aiMusicChatStep = 2;
        this.textAreaMaxLength = 3000;
        this.mode = 1;
        this.chatList.push({
          type: 'me',
          contents: text
        });
        // 직접입력
        this.chatList.push({
          type: 'aimusic-manual'
        });
        await this.$nextTick();
        this.typed(
          this.$refs.aiMusicManual[0],

          parser.parseFromString(`알겠어요! &lt;br&gt; ${this.spacename} 로고송의 가사를 입력해 주세요!`, 'text/html')
            .body.textContent,
          () => {
            setTimeout(() => {
              this.scrollBottom();
              this.$refs.chatTextAreaBox.onClickBox();
            }, 500);
            this.isSelectedLyrics = false;
          }
        );
      } else if (type === 'ai-generated') {
        this.$gatag.event('web_ai_music_generate_page_chat_lyrics_by_ai'); // 로고송 가사 자동 생성
        this.aiMusicChatStep = 1;
        this.textAreaMaxLength = 300;
        this.mode = 2;
        // 메세지 추가
        this.chatList.push({
          type: 'me',
          contents: text
        });
        // AI가 생성
        this.chatList.push({
          type: 'aimusic-generated'
        });
        await this.$nextTick();

        this.typed(
          this.$refs.aiMusicGenerated[0],
          parser.parseFromString(`알겠어요! &lt;br&gt; 음악은 어떤 분위기로 만들어 볼까요?`, 'text/html').body
            .textContent,
          () => {
            setTimeout(() => {
              this.scrollBottom();

              this.$refs.chatTextAreaBox.onClickBox();
              this.isSelectedLyrics = false;
            }, 500);
          }
        );
        await this.$nextTick();
      }
    }
  },
  computed: {
    aiMusicExampleText() {
      if (this.aimusiceExampleList) {
        return this.aimusiceExampleList.join(', ');
      }
      return null;
    },
    isInputDisabled() {
      if (this.isLoading) {
        return true;
      } else {
        if (this.aichanneltype === 'addspace') {
          if (this.isSelectedColor && this.isSelectMaterial && this.isSelectTarget) {
            return this.btnDisabled;
          }
          return true;
        }

        return this.btnDisabled;
      }
    },
    channelName() {
      if (this.aichanneltype === 'addspace') {
        return this.spacename;
      } else {
        if (this.$store.getters['player/getMyChannelInfo']) {
          return this.$store.getters['player/getMyChannelInfo'].channelNm;
        }

        return '';
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/aichat/aichat.css"></style>
